import { MediaDto } from './media.dto';
import { ProductDiscountedPriceDto } from './product-discounted-price.dto';

export class WishlistItemDto {
  productId: number;
  createTime?: Date;
  name?: string;
  slug?: string;
  medias?: MediaDto[];
  price?: number;
  oldPrice?: number;
  discountedPrices?: ProductDiscountedPriceDto[];
  isInStock?: boolean;
  sku?: string;
  isInWishlist: boolean;
  isLoading?: boolean;

  constructor(productId: number) {
    this.productId = productId;
    this.isInWishlist = true;
  }

}
